import { render, staticRenderFns } from "./RamSwapGraph.vue?vue&type=template&id=deeafe78&scoped=true&"
import script from "./RamSwapGraph.vue?vue&type=script&lang=js&"
export * from "./RamSwapGraph.vue?vue&type=script&lang=js&"
import style0 from "./RamSwapGraph.vue?vue&type=style&index=0&id=deeafe78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deeafe78",
  null
  
)

export default component.exports